import { getVehicleInfoByLorryType } from "@vahak/core/dist/constants/lorryTypes";

export function getLoadDisplayBodyType(lorryTypeId?: number, bodyType?: number): string | undefined {
    if (!lorryTypeId || bodyType == null) {
        return undefined;
    }

    return getVehicleInfoByLorryType(lorryTypeId, "load")?.bodyOptions?.find((option) => option.id === bodyType)?.name;
}
